export enum DPValidationType {
  RegEx = 1,
  DurationMonthTotal,
  StartEndDateTotal,
  MaxLength,
  MinLength,
  DateOfBirth,
  InvalidateFutureDate,
  InvalidatePastDate,
  DateOfBirthPlus,
  CurrentResidence,
  StartEndDateGap,
  DriverLicence,
  DateYearLimit,
  MinDateYearLimit,
  EmploymentHireDate,
  EmploymentResponseConflict,
  MinStartDate,
  MaxEndDate,
}
